module.exports = __webpack_public_path__ + "static/scrapbook-c8bde68150869cd84867491a9a4a7621.png";